import { render } from "./BaseSmallButton.vue?vue&type=template&id=72b80682&scoped=true&ts=true"
import script from "./BaseSmallButton.vue?vue&type=script&lang=ts"
export * from "./BaseSmallButton.vue?vue&type=script&lang=ts"

import "./BaseSmallButton.vue?vue&type=style&index=0&id=72b80682&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b80682"]])

export default __exports__